import React from 'react';
import { Card, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';

const TagCard = ({ tags }) => {
  const navigate = useNavigate();
  const tagList = tags.split(',');

  const handleTagClick = (tag) => {
    const trimmedTag = tag.trim();
    navigate(`/search/${encodeURIComponent(trimmedTag)}`);
  };

  return (
    <Card title="Tags" className="w-full max-w-md shadow-md hover:shadow-lg transition-shadow">
      <div className="flex flex-wrap gap-2">
        {tagList.map((tag, index) => (
          <Tag
            key={index}
            color="green"
            className="cursor-pointer"
            style={{ cursor: 'pointer' }}
            onClick={() => handleTagClick(tag)}
          >
            {tag.trim()}
          </Tag>
        ))}
      </div>
    </Card>
  );
};

export default TagCard;
